import { ModuleTagging, StrictNodeModel } from '../types';

import { resolveFilterPath } from './resolveFilterPath';

/**
 * Returns the visible children of a node, resolving `filterTagPath` children
 * from `moduleTagging` the same way the hub does at build time.
 */
export function getEffectiveChildren(
  node: StrictNodeModel,
  moduleTagging: readonly ModuleTagging[],
): readonly StrictNodeModel[] {
  const children =
    node.filterTagPath && node.filterRoot
      ? resolveFilterPath(node, moduleTagging)
      : node.children;
  return children.filter((c) => !c.hidden);
}
